var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "52058B4B-EDD1-4D87-A1AC-ED0607DADD98") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-759.000000, -771.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(744.000000, 756.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8,0 L15.4,0 L7.3,8.1 C6.1,9.3 5.4,10.9 5.4,12.6 L5.4,15.4 L8.2,15.4 C9.9,15.4 11.5,14.7 12.7,13.5 L20.8,5.4 L20.8,5 C20.8,3.7 20.3,2.4 19.3,1.4 C18.4,0.6 17.1,0 15.8,0 L15.8,0 Z M11.3,12.2 C10.5,13 9.4,13.5 8.2,13.5 L7.4,13.5 L7.4,12.7 C7.4,11.5 7.9,10.4 8.7,9.6 L16.2,2.1 C16.9,2.2 17.5,2.5 17.9,3 C18.4,3.5 18.7,4.1 18.8,4.7 L11.3,12.2 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4,20.8 L13.8,20.8 C15,20.8 16.1,20.3 16.9,19.5 C17.7,18.7 18.2,17.6 18.2,16.4 L18.2,13.4 L16.2,13.4 L16.2,16.4 C16.2,17 16,17.6 15.5,18.1 C15.1,18.5 14.5,18.8 13.8,18.8 L4.4,18.8 C3.8,18.8 3.2,18.6 2.7,18.1 C2.2,17.6 2,17.1 2,16.4 L2,7 C2,6.4 2.2,5.8 2.7,5.3 C3.1,4.9 3.7,4.6 4.4,4.6 L7.4,4.6 L7.4,2.6 L4.4,2.6 C3.2,2.6 2.1,3.1 1.3,3.9 C0.5,4.7 0,5.8 0,7 L0,16.4 C0,17.6 0.5,18.7 1.3,19.5 C2.1,20.3 3.2,20.8 4.4,20.8 L4.4,20.8 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.503c57efd7780828a45721eb3385a3ed.svg";
export { ForwardRef as ReactComponent };